import { useCallback, useRef } from "react";
import { ListTableValidator } from "./types";

export const useListTableValidators = () => {
   const validatorsRef = useRef<Record<string, ListTableValidator>>({});

   const registerListTableValidator = useCallback(
      (fieldId: string, validator: ListTableValidator) => {
         if (!fieldId) return;
         validatorsRef.current[fieldId] = validator;
      },
      [],
   );

   const unregisterListTableValidator = useCallback((fieldId: string) => {
      if (!fieldId) return;
      delete validatorsRef.current[fieldId];
   }, []);

   const getValidator = useCallback((fieldId: string) => {
      return validatorsRef.current[fieldId];
   }, []);

   return {
      registerListTableValidator,
      unregisterListTableValidator,
      getValidator,
   };
};
